import { render, staticRenderFns } from "./UpsRedirect.vue?vue&type=template&id=1c7863fa&scoped=true&lang=pug&"
import script from "./UpsRedirect.vue?vue&type=script&lang=js&"
export * from "./UpsRedirect.vue?vue&type=script&lang=js&"
import style0 from "./UpsRedirect.vue?vue&type=style&index=0&id=1c7863fa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7863fa",
  null
  
)

/* custom blocks */
import block0 from "./UpsRedirect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports